import { siGithub, siInstagram, siLinkedin, siSpotify } from 'simple-icons/icons';

// @ts-ignore
import NexusLogo from "bundle-text:@assets/logos/nexus.svg";

export default [
    {
        name: "Github",
        icon: siGithub.svg,
        link: "https://github.com/Tangerie"
    },
    {
        name: "Instagram",
        icon: siInstagram.svg,
        link: "https://www.instagram.com/tangerie.dev/"
    },
    {
        name: "LinkedIn",
        icon: siLinkedin.svg,
        link: "https://www.linkedin.com/in/joshua-cavill-958164190/"
    },
    {
        name: "Spotify",
        icon: siSpotify.svg,
        link: "https://open.spotify.com/user/sharbyboy03?si=32c3cec20e144b25"
    },
    {
        name: "Nexus",
        icon: NexusLogo,
        link: "https://www.nexusmods.com/users/174872460?tab=user+files"
    }
]